import React from 'react'
import { Redirect, useLocation } from 'react-router'
import qs from 'qs'

import SessionTimeline from './SessionTimeline'

import { Routes } from '../../Routes'

const Timeline = () => {
  const location = useLocation()

  const { session } = React.useMemo(
    () => qs.parse(location.search, { ignoreQueryPrefix: true }),
    [location.search]
  )

  // Go to client chats if no params were provided
  if (!session) {
    return <Redirect to={Routes.CLIENT_CHATS} />
  }

  return <SessionTimeline session={session} />
}

export default Timeline
